import { render } from "./TextHiting.vue?vue&type=template&id=10ee0dad&scoped=true"
import script from "./TextHiting.vue?vue&type=script&lang=js"
export * from "./TextHiting.vue?vue&type=script&lang=js"

import "./TextHiting.vue?vue&type=style&index=0&id=10ee0dad&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ee0dad"]])

export default __exports__